import { useNavigate } from 'react-router';

import { NoticeModal } from 'components/ui/notice-modal';
import { useModal } from 'context/ModalContext';

import { markTasksAsRead, TASKS_PENDING_APPROVAL_MODAL_ID } from './read-notifications';

interface IProps {
  tasks: any[] | undefined;
}

export function TasksPendingApprovalParticipantsModal({ tasks }: IProps) {
  const navigate = useNavigate();
  const { openModal, closeModal } = useModal();

  if (!Array.isArray(tasks) || !tasks.length) return null;

  const pendingTasks = tasks;

  function handleClose() {
    markTasksAsRead(pendingTasks);
    closeModal();
  }

  function handleSeeTask() {
    markTasksAsRead(pendingTasks);
    navigate('/minha-equipe/participantes-da-realizacao');
  }

  return (
    <NoticeModal
      isOpen={openModal === TASKS_PENDING_APPROVAL_MODAL_ID}
      title="Autorização de participação em Realização Destaque"
      actionLabel="Ver realização"
      onAction={handleSeeTask}
      onClose={handleClose}
      closeLabel="Fechar aviso"
    >
      <p className="m-0">
        O seu prefixo tem <strong>Realização Destaque com mais de 20 participantes pendente</strong> de autorização.
      </p>
      <p className="m-0">
        OBS.: Caso queira autorizar a participação depois, basta acessar a página{' '}
        <strong>Minha equipe {'>'} Avaliar número de participantes em realização</strong>. Lá você encontrará o card da realização
        sinalizado pelo status e pronto para autorizar ou recusar a quantidade de participantes na realização.
      </p>
    </NoticeModal>
  );
}
